import has from "lodash/has";
import {getDataInLocalStorage} from "../../_common/localStorage";

function missingImageReported(productCode) {
  return getDataInLocalStorage(`missing-image-reported-${productCode}`) === "true";
}

function showReportMissingImageLink(element) {
  element.classList.remove("product-tile__report-missing-image__hidden");
}
function showMissingImageReported(message) {
  message.classList.remove("product-tile__report-missing-message__hidden");
}

export default function addProductImages(products, { images }) {
  products.forEach((product: HTMLElement) => {
    const code = product.dataset.productCode;
    const productImage = product.querySelector(`.product-tile__img`);
    if (has(images, `${code}[0].resolutions.w280.url`)) {
      productImage.src = images[code][0].resolutions.w280.url;
    } else {
      productImage.src = `/search/static/images/image-unavailable.jpg`;

      const missingLink = product.querySelector(`.product-tile__report-missing-image-${code}`);
      const reportedMessage = product.querySelector(`.product-tile__report-missing-message-${code}`);
      if (missingLink && !missingImageReported(code)) {
        showReportMissingImageLink(missingLink);
      }
      if (reportedMessage && missingImageReported(code)) {
        showMissingImageReported(reportedMessage);
      }
    }

    if (has(images, `${code}[0].title`)) {
      productImage.alt = images[code][0].title;
    } else {
      productImage.alt = `None available`;
    }
    productImage.parentElement.classList.remove(`product-tile__img-link-loading`);
  });
}
